import { Lang } from '@/core/types/lang'

export class LangChangeLang {
  static readonly type = '[Lang] ChangeLang'
  constructor(public lang: Lang) {}
}
